import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { GET_PERM_AGENCIES } from 'constants/api';
import { Box, Select, TextField } from 'components/AORedesign';
import useFetchSelectMenuItems from 'hooks/useFetchSelectMenuItems';
import { toAgencyOption } from './DbcReport.api';

const DbcAgentAgencyPicker = ({ agencyCode, onAgencyCodeChange }) => {
  const [agencyOptions, setAgencyOptions] = useState([]);

  useFetchSelectMenuItems(GET_PERM_AGENCIES, ({ data }) => setAgencyOptions(data.map(toAgencyOption)));

  // The dropdown and the code field share one value; only show it in the dropdown when it is a permitted agency.
  const selectedAgency = agencyOptions.some(({ value }) => value === agencyCode) ? agencyCode : '';
  const handleChange = (e) => onAgencyCodeChange(e.target.value);

  return (
    <>
      <Box mb={2}>
        <Select
          id="dbc-agency-name-dropdown"
          labelId="dbc-agency-name-dropdown-label"
          label="Select Location"
          name="agencyName"
          menuItems={agencyOptions}
          value={selectedAgency}
          onChange={handleChange}
        />
      </Box>
      <Box mb={2}>
        <TextField id="dbc-agency-code" label="Agency Code" placeholder="Enter Search Input" value={agencyCode} onChange={handleChange} />
      </Box>
    </>
  );
};

DbcAgentAgencyPicker.propTypes = {
  agencyCode: PropTypes.string.isRequired,
  onAgencyCodeChange: PropTypes.func.isRequired,
};

export default DbcAgentAgencyPicker;
